import { CompositeLayer, UpdateParameters } from "@deck.gl/core"
import { BitmapLayer } from "@deck.gl/layers"
import { MapLayerImage } from "../types"
import { getGlobalTerrainData } from "features/map/GlobalTerrainManager"

export default class OrthoOverlapLayer extends CompositeLayer<MapLayerImage> {
    static layerName = "OrthoOverlapLayer"

    updateState({ props, changeFlags }: UpdateParameters<this>): void {
        if (changeFlags.dataChanged) {
            this.setState({ layers: (props.data || []) as MapLayerImage[] })
        }
    }

    renderLayers() {
        return (this.state.layers as MapLayerImage[])
            .filter((layer) => layer.isVisible)
            .map(
                (layer) =>
                    new BitmapLayer({
                        id: `ortho-overlap-layer-${layer.flightId}`,
                        image: layer.imageData,
                        extensions: [...getGlobalTerrainData().extensions],
                        bounds: layer.bbox as [number, number, number, number],
                    })
            )
    }
}
